/*
 * File: OrderCardCaption.js
 * Project: mp-mobile-app
 *
 * Created by Rob Rothe
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Component to output the status and status indicator for
 * an order card
 */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import OrderStatusIndicator from "./OrderStatusIndicator";
import OrderReferences from "../store/OrderReferences";
import { withStyles } from "@material-ui/core/styles";
import { useStore, StoreContext } from "utils/useStore";

const styles = theme => ({
  cardHeader: {
    fontWeight: 500,
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(-1)
  }
});

const OrderStatusReporter = ({ order, classes }) => {
  const storeManager = useContext(StoreContext);
  const orderReferences = useStore(OrderReferences);
  const orderStatusIndicator = () => {
    const openStatusIds = orderReferences.getOpenStatusIds();
    if (openStatusIds.includes(order.orderStatusId))
      return <OrderStatusIndicator statusId={order.orderStatusId} />;
  };

  return (
    <Typography className={classes.cardHeader} variant="subtitle1">
      {order.statusString(storeManager)} {orderStatusIndicator()}
    </Typography>
  );
};

OrderStatusReporter.propTypes = {
  order: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OrderStatusReporter);
